import apiClient from './apiClient';

// Definición de la interfaz
export interface PlannedScheduleDTO {
  activityId: number;
  activityName: string;
  subActivity: string | null;
  plannedTimeline: Record<string, number>;
  realTimeline: Record<string, number>;
}

export const getScheduleByProjectId = async (projectId: number) => {
  // Cambiamos axios.get por apiClient.get
  const response = await apiClient.get(`/schedule/project/${projectId}`);
  return response;
};

export const saveProjectSchedule = async (projectId: number, payload: PlannedScheduleDTO[]) => {
  // Cambiamos axios.post por apiClient.post
  const response = await apiClient.post(`/schedule/project/${projectId}`, payload);
  return response;
};